import { render, staticRenderFns } from "./TeamDetailsComponent.vue?vue&type=template&id=b0b0d9d8&scoped=true"
import script from "./TeamDetailsComponent.vue?vue&type=script&lang=js"
export * from "./TeamDetailsComponent.vue?vue&type=script&lang=js"
import style0 from "./TeamDetailsComponent.vue?vue&type=style&index=0&id=b0b0d9d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0b0d9d8",
  null
  
)

export default component.exports